import React, { useEffect, useState } from "react";
const initialErrorData = {
  pradeshName: "",
  mandalName: "",
  areaName: "",
  designationName: "",
};
const Steps5 = ({ count, setCount, detailsSet, details, initialData,completeCurrentStep }) => {
  const [formData, setFormData] = useState();
  const [errors, setErrors] = useState(initialErrorData);

  useEffect(() => {
    setFormData(details);
  }, [details]);

  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      if (name === "disabilityCheck") {
        setFormData({ ...formData, [name]: e.target.checked });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    }

    // Clear errors for the field if it is filled
    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
  // Validate the form fields
  const validateForm = () => {
    const newErrors = { ...initialErrorData };
    let isValid = true;

    Object.keys(newErrors).forEach((key) => {
      if (!formData[key] || formData[key].trim() === "") {
        newErrors[key] = `Please enter ${key}`;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      console.log("Form Data:", formData);
      // Proceed with the next step or any other logic
      detailsSet(formData); // Assuming this sets form data in a parent state
      setCount(count + 1); // Assuming this moves to the next step
      completeCurrentStep(count);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* <div className="stepProgrees text-start mt-2">
        <p className="d-flex tittle-text mb-0">
          <b style={{ color: "#034DA2" }} className="">
          Mandal Info
          </b>
        </p>
        <p style={{ color: "#034DA2" }} className="tittle-text mb-0">
        Mandal Info
        </p>
      </div> */}
      <div className="mt-4 main p-4 border rounded-4  bg-white">
        <div className="row ">
          <div className="col-md-6">
            <label className="tittle-text" htmlFor="Pradesh Name">
              * Pradesh Name
            </label>
            <select
              name="pradeshName"
              value={formData?.pradeshName}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
                <option className="inputText" value="">
                Select...
              </option>
              {initialData?.pradesh?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.pradeshName && (
              <span className="text-danger  fw-medium d-inline-flex">
                {errors?.pradeshName}
              </span>
            )}
          </div>

          <div className="col-md-6">
            <label className="tittle-text" htmlFor="Professional Education">
              {" "}
              * Mandal Name
            </label>
            <select
              name="mandalName"
              value={formData?.mandalName}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option className="inputText" value="">
                Select...
              </option>
              {initialData?.mandal?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.mandalName && (
              <span className="text-danger  fw-medium d-inline-flex">
                {errors?.mandalName}
              </span>
            )}
          </div>

          <div className="col-md-6 mt-4">
            <label className="tittle-text" htmlFor="areaname">
              * Area Name
            </label>
            <select
              name="areaName"
              value={formData?.areaName}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option className="inputText" value="">
                Select...
              </option>
              {initialData?.area?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.areaName && (
              <span className="text-danger  fw-medium d-inline-flex">
                {errors?.areaName}
              </span>
            )}
          </div>
          <div className="col-md-6 mt-4">
            <label className="tittle-text" htmlFor="name">
              * Designation Name
            </label>
            <select
              name="designationName"
              value={formData?.designationName}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option className="inputText" value="mr">
                Select...
              </option>
              {initialData?.designation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.designationName && (
              <span className="text-danger   fw-medium d-inline-flex">
                {errors?.designationName}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            className="rounded-5 btnBlue btn"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}
        {count < 5 && (
          <button
            type="submit"
            className="rounded-5 btnBlue btn"
            // onClick={() => setCount(count + 1)}
          >
            Next
          </button>
        )}
      </div>
    </form>
  );
};

export default Steps5;
